<script>

  export default {
    name: 'VillageSelect',
    props: ["defaultValue"],
    data() {
      return {
        selectRole: null,
        roleEnum: [
          {
            label: '抄表员',
            value: 4
          },
          {
            label: '收费员',
            value: 3
          }
        ]
      }
    },
    watch: {
      defaultValue(val) {
        this.selectRole = val
      }
    },
    methods: {
      roleChange(value) {
        this.$emit('roleChange', value)
      },
    }
  }
</script>

<template>
  <el-select v-model="selectRole" clearable placeholder="角色" @change="roleChange">
    <el-option
      v-for="item in roleEnum"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/EmployeeSelect.vue